import React, { useState, useEffect, useRef } from 'react';
import { Link, Copy, Check, Zap, BarChart3, Shield, Scissors, ArrowRight, Github, QrCode, Star, Infinity, User, CheckCircle2, XCircle, Globe, Download } from 'lucide-react';
import axios from 'axios';
// 1. ฐานข้อมูลคำแปล (Translation Dictionary)
const translations = {
  th: {
    nav: {
      features: "ฟีเจอร์ & ราคา",
      help: "ช่วยเหลือ",
      login: "เข้าสู่ระบบ",
      start: "เริ่มต้นฟรี"
    },
    hero: {
      titlePrefix: "ย่อลิงก์ของคุณให้",
      titleHighlight1: "สั้นลง",
      titleMiddle: "แชร์ได้",
      titleHighlight2: "ง่ายขึ้น",
      subtitle: "เครื่องมือจัดการลิงก์ที่ทรงพลัง สำหรับนักการตลาดและทุกคน ใช้งานฟรี รวดเร็ว พร้อมระบบติดตามสถิติที่แม่นยำ",
      placeholder: "วางลิงก์ยาวๆ ของคุณที่นี่ (เช่น https://super-long-website.com/...)",
      buttonShorten: "ย่อลิงก์เลย",
      buttonLoading: "กำลังย่อ...",
      errorEmpty: "กรุณาวางลิงก์ที่ต้องการย่อ",
      errorInvalid: "ลิงก์ต้องขึ้นต้นด้วย http:// หรือ https://"
    },
    result: {
      success: "ย่อลิงก์สำเร็จ!",
      expiryGuest: "Guest URL: หมดอายุ 3 เดือน",
      copy: "คัดลอก",
      copied: "คัดลอกแล้ว",
      qrHide: "ซ่อน QR",
      qrShow: "QR",
      scan: "สแกนเพื่อเปิดลิงก์",
      downloadQR: "ดาวน์โหลด QR"
    },
    features: {
      fastTitle: "รวดเร็วทันใจ",
      fastDesc: "ระบบประมวลผลประสิทธิภาพสูง ย่อลิงก์ได้ภายในเสี้ยววินาที",
      statsTitle: "สถิติเรียลไทม์",
      statsDesc: "สำหรับสมาชิกระดับรายปี ดูข้อมูลเชิงลึกได้ทันที",
      safeTitle: "ปลอดภัย 100%",
      safeDesc: "ลิงก์ผ่านการตรวจสอบความปลอดภัย HTTPS มาตรฐานสากล"
    },
    history: {
      title: "ลิงก์ล่าสุดของคุณ (Guest)",
      empty: "ยังไม่มีประวัติการย่อลิงก์",
      clicks: "คลิก"
    },
    pricing: {
      headerTitle: "แผนการใช้งาน",
      headerMain: "เลือกแผนที่เหมาะกับคุณ",
      headerSub: "เริ่มต้นใช้งานฟรีได้ทันที หรืออัปเกรดเพื่อฟีเจอร์ที่เหนือกว่า",
      guest: {
        title: "Guest (ผู้เยี่ยมชม)",
        desc: "สำหรับผู้ต้องการย่อลิงก์ด่วน",
        price: "ฟรี",
        period: "/ ตลอดไป",
        btn: "เริ่มใช้งานเลย",
        f1: "ไม่ต้องลงทะเบียน",
        f2: "อายุลิงก์ 3 เดือน",
        f3: "สร้าง QR Code พื้นฐาน",
        f4: "ไม่มีระบบสถิติ",
        f5: "ไม่สามารถแก้ไข URL เองได้"
      },
      general: {
        title: "สมาชิกทั่วไป",
        desc: "สำหรับการใช้งานที่มากขึ้น",
        price: "ฟรี",
        period: "/ สมัครสมาชิก",
        btn: "สมัครสมาชิกฟรี",
        badge: "ยอดนิยม",
        f1: "จัดการลิงก์ในระบบหลังบ้าน",
        f2: "อายุลิงก์ 1 ปี",
        f3: "สร้างได้สูงสุด 300 URLs",
        f4: "ดูประวัติการสร้างย้อนหลัง"
      },
      annual: {
        title: "สมาชิกรายปี",
        desc: "สำหรับมืออาชีพและธุรกิจ",
        price: "฿990",
        period: "/ ปี",
        btn: "อัปเกรดเลย",
        f1: "อายุลิงก์ไม่หมดอายุ",
        f2: "สร้างลิงก์ได้ไม่จำกัด",
        f3: "Custom URL (ระบุชื่อเอง) ได้ 10 ชื่อ",
        f4: "ดูสถิติการคลิกอย่างละเอียด",
        f5: "ไม่มีโฆษณา"
      }
    },
    footer: {
        rights: "All rights reserved.",
        privacy: "Privacy",
        terms: "Terms"
    }
  },
  en: {
    nav: {
      features: "Features & Pricing",
      help: "Help",
      login: "Log In",
      start: "Get Started"
    },
    hero: {
      titlePrefix: "Make your links",
      titleHighlight1: "Shorter",
      titleMiddle: "Share them",
      titleHighlight2: "Easier",
      subtitle: "A powerful link management tool for marketers and everyone. Free, fast, and accurate statistics.",
      placeholder: "Paste your long link here (e.g. https://super-long-website.com/...)",
      buttonShorten: "Shorten Now",
      buttonLoading: "Shortening...",
      errorEmpty: "Please paste a link to shorten",
      errorInvalid: "Link must start with http:// or https://"
    },
    result: {
      success: "Shortened Successfully!",
      expiryGuest: "Guest URL: Expires in 3 months",
      copy: "Copy",
      copied: "Copied",
      qrHide: "Hide QR",
      qrShow: "QR",
      scan: "Scan to open link",
      downloadQR: "Download QR"
    },
    features: {
      fastTitle: "Blazing Fast",
      fastDesc: "High-performance processing system. Shorten links in milliseconds.",
      statsTitle: "Real-time Stats",
      statsDesc: "For annual members. View insights instantly.",
      safeTitle: "100% Secure",
      safeDesc: "Links are checked for safety with standard HTTPS."
    },
    history: {
      title: "Your Recent Links (Guest)",
      empty: "No history yet",
      clicks: "clicks"
    },
    pricing: {
      headerTitle: "Pricing Plans",
      headerMain: "Choose the plan that fits you",
      headerSub: "Start for free immediately, or upgrade for better features.",
      guest: {
        title: "Guest",
        desc: "For quick link shortening",
        price: "Free",
        period: "/ Forever",
        btn: "Start Now",
        f1: "No registration required",
        f2: "Link expires in 3 months",
        f3: "Basic QR Code generation",
        f4: "No statistics",
        f5: "Cannot edit URL"
      },
      general: {
        title: "General Member",
        desc: "For more usage",
        price: "Free",
        period: "/ Sign Up",
        btn: "Sign Up Free",
        badge: "Popular",
        f1: "Manage links in dashboard",
        f2: "Link expires in 1 year",
        f3: "Create up to 300 URLs",
        f4: "View creation history"
      },
      annual: {
        title: "Annual Member",
        desc: "For professionals and business",
        price: "฿990",
        period: "/ Year",
        btn: "Upgrade Now",
        f1: "Links never expire",
        f2: "Unlimited link creation",
        f3: "10 Custom URLs",
        f4: "Detailed click statistics",
        f5: "No ads"
      }
    },
    footer: {
        rights: "All rights reserved.",
        privacy: "Privacy",
        terms: "Terms"
    }
  }
};

  const config = {
    shortdomain: "m108.com",
    posturl: "https://short.m108.com/api/yourls-url",
    loginurl: "https://short.m108.com/api/api/login",
    //loginurl: "http://127.0.0.1:3001/api/login",
    //posturl: "http://127.0.0.1:3001/yourls-url",
    
  }



export default function ShortURL1() {
  const [lang, setLang] = useState('th'); // 'th' | 'en'
  const [currentPage, setCurrentPage] = useState('home'); // 'home' | 'features'
  const [longUrl, setLongUrl] = useState('');
  const [shortenedResult, setShortenedResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState('');
  const [copiedId, setCopiedId] = useState(null);
  const [showQr, setShowQr] = useState(false);
  const [token, setToken] = useState(null);
  const canvasRef = useRef(null);
  
  // Helper เพื่อดึงข้อความตามภาษาปัจจุบัน
  const t = translations[lang];

  useEffect(() => {
    const mockHistory = [
      //{ original: 'https://www.example.com/super-long-url-for-test', short: 'm108.com/x9Bz2', clicks: 120, date: '2023-10-20' },
     // { original: 'https://thailand-travel.com/phuket-guide', short: 'm108.com/Pk7m1', clicks: 45, date: '2023-10-22' },
    ];
    setHistory(mockHistory);
    //loadLogin();
   
    //console.log('load history');

  //   if(token == null){

  //   const response = axios.get(config.loginurl, {
  //   }).then((response) => {
  //     //console.log(response.data);
  //     setToken(response.data.token);
  //   }).catch((error) => {
  //     console.error(error);
  //   })
  // }

  }, []);

  // on Homepage load
  //useEffect(() => {
    //console.log(this);
    //const loadLogin = async () => {
    
//}
  //}, [ ]);

  // ฟังก์ชันโหลด Script QRious
  const loadQrLibrary = () => {
    return new Promise((resolve, reject) => {
      if (window.QRious) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrious/4.0.2/qrious.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    if (showQr && shortenedResult && canvasRef.current) {
      loadQrLibrary().then(() => {
        if (window.QRious) {
          new window.QRious({
            element: canvasRef.current,
            value: shortenedResult.short,
            size: 200,
            level: 'H',
            foreground: '#0891b2',
            background: 'white',
          });
        }
      }).catch(err => console.error("Failed to load QR library", err));
    }
  }, [showQr, shortenedResult]);

  const handleShorten = async (e) => {
    e.preventDefault();


      //console.log(isLoading);

    const response =   await axios.get(config.loginurl, {
    })
    //.then((response) => {
      //console.log(response.data);
      
      setToken(response.data.token);
      //console.log(response.data.token);
      //console.log( `Bearer ${token}`);
   // }).catch((error) => {
    //  console.error(error);
    //})
    


    setError('');
    setShortenedResult(null);
    setShowQr(false);

    if (!longUrl) {
      setError(t.hero.errorEmpty);
      return;
    }
    if (!longUrl.startsWith('http')) {
      setError(t.hero.errorInvalid);
      return;
    }

    setIsLoading(true);

    //setTimeout(() => {

var randomCode = '';
try {
        // สร้าง URL พร้อมพารามิเตอร์ Page และ Sort
        const response2 =  await axios.post(
          //`${API_BASE_URL}?page=${currentPage}&sort_by=${sortConfig.key}&sort_direction=${sortConfig.direction}`
        config.posturl,
        { "url": longUrl},{
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${response.data.token}`
  }
}
        ).then(function (response2) {
    //console.log(response.data.surl);
    randomCode = response2.data.surl;

    //const randomCode = Math.random().toString(36).substring(2, 7);
      const newShortUrl = `${config.shortdomain}/${randomCode}`;
      
      // Format date based on language
      const dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
      const dateStr = new Date().toLocaleDateString(lang === 'th' ? 'th-TH' : 'en-US', dateOptions);

      const result = {
        original: longUrl,
        short: newShortUrl,
        clicks: 0,
        date: dateStr
      };
//console.log(result);
      setShortenedResult(result);
      setHistory([result, ...history]);
      setIsLoading(false);
      setLongUrl('');
  })
        //console.log(response.data);
      }catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to fetch data');
      }



      


    //}, 100);
  };

  const copyToClipboard = (text, id) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (err) {
      console.error('Unable to copy', err);
    }
    document.body.removeChild(textArea);
  };

  const toggleLang = () => {
    setLang(prev => prev === 'th' ? 'en' : 'th');
  };

  const handleDownloadQR = () => {
    if (canvasRef.current) {
      const url = canvasRef.current.toDataURL("image/png");
      const link = document.createElement("a");
      link.download = `qrcode-${shortenedResult.short.split('/').pop()}.png`;
      link.href = url;
      link.click();
    }
  };

  // --- Components ---

  const HomePage = () => (
    <>
      <main className="pt-16 pb-24 relative overflow-hidden">
        <div className="absolute top-20 left-0 w-72 h-72 bg-cyan-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
        <div className="absolute top-20 right-0 w-72 h-72 bg-yellow-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-4000"></div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900 mb-6">
            {t.hero.titlePrefix} <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600">{t.hero.titleHighlight1}</span> <br />
            {t.hero.titleMiddle} <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-pink-500">{t.hero.titleHighlight2}</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl mx-auto">
            {t.hero.subtitle}
          </p>
          
 <></>
          {/* Input Card */}
          <div className="bg-white p-2 rounded-2xl shadow-xl shadow-slate-200/60 border border-slate-100 max-w-3xl mx-auto transform transition-all hover:scale-[1.01]">
            <form onSubmit={handleShorten} className="flex flex-col md:flex-row gap-2">
              <div className="relative flex-grow">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Link className="h-5 w-5 text-slate-400" />
                </div>
                <input
                  type="text"
                  className="block w-full pl-11 pr-4 py-4 bg-slate-50 border-transparent text-slate-900 placeholder-slate-400 focus:bg-white focus:border-cyan-500 focus:ring-2 focus:ring-cyan-200 rounded-xl text-base transition-all outline-none"
                  placeholder={t.hero.placeholder}
                  value={longUrl}
                  onChange={(e) => setLongUrl(e.target.value)}
                />


              </div>
              <button
                type="submit"
                disabled={isLoading}
                className={`px-8 py-4 rounded-xl font-bold text-white text-lg shadow-lg shadow-cyan-500/30 flex items-center justify-center gap-2 transition-all
                  ${isLoading 
                    ? 'bg-cyan-300 cursor-not-allowed' 
                    : 'bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 hover:shadow-cyan-500/40 active:scale-95'
                  }`}
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {t.hero.buttonLoading}
                  </>
                ) : (
                  <>
                    {t.hero.buttonShorten} <ArrowRight size={20} />
                  </>
                )}
              </button>
            </form>
          </div>
          {error && (
            <div className="mt-4 text-red-500 bg-red-50 px-4 py-2 rounded-lg inline-block text-sm font-medium animate-bounce">
              {error}
            </div>
          )}

          {/* Result Card */}
          {shortenedResult && (
            <div className="mt-8 max-w-2xl mx-auto bg-white rounded-2xl border border-cyan-100 shadow-lg overflow-hidden animate-fade-in-up">
              <div className="bg-gradient-to-r from-cyan-50 to-blue-50 px-6 py-4 border-b border-cyan-100 flex justify-between items-center">
                <span className="text-sm font-semibold text-cyan-700 flex items-center gap-2">
                  <Check size={16} /> {t.result.success}
                </span>
                <span className="text-xs text-slate-500">{t.result.expiryGuest}</span>
              </div>
              <div className="p-6">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                  <div className="text-left overflow-hidden w-full">
                    <p className="text-sm text-slate-500 truncate mb-1 line-through decoration-slate-300">{shortenedResult.original}</p>
                    <p className="text-2xl font-bold text-cyan-600 break-all">{shortenedResult.short}</p>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                     <button
                        onClick={() => setShowQr(!showQr)}
                        className={`flex-shrink-0 px-4 py-3 rounded-xl font-bold transition-all flex items-center justify-center gap-2
                        ${showQr
                            ? 'bg-cyan-100 text-cyan-700' 
                            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                        }`}
                    >
                        <QrCode size={20} />
                        {showQr ? t.result.qrHide : t.result.qrShow}
                    </button>
                    <button
                        onClick={() => copyToClipboard(shortenedResult.short, 'new')}
                        className={`flex-shrink-0 px-6 py-3 rounded-xl font-bold transition-all flex items-center justify-center gap-2
                        ${copiedId === 'new' 
                            ? 'bg-green-500 text-white shadow-green-500/30' 
                            : 'bg-cyan-900 text-white hover:bg-slate-800 shadow-xl shadow-slate-900/20'
                        }`}
                    >
                        {copiedId === 'new' ? <Check size={20} /> : <Copy size={20} />}
                        {copiedId === 'new' ? t.result.copied : t.result.copy}
                    </button>
                  </div>
                </div>
                {showQr && (
                    <div className="mt-6 pt-6 border-t border-slate-100 flex flex-col items-center justify-center animate-fade-in">
                        <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-inner">
                            <canvas ref={canvasRef} className="w-48 h-48 object-contain"></canvas>
                        </div>
                        <p className="mt-3 text-sm text-slate-500">{t.result.scan}</p>
                        <button
                          onClick={handleDownloadQR}
                          className="mt-4 flex items-center gap-2 px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 transition-all text-sm font-bold shadow-md shadow-cyan-600/20"
                        >
                          <Download size={16} />
                          {t.result.downloadQR}
                        </button>
                    </div>
                )}
              </div>
            </div>
          )}
        </div>
      </main>

      <section className="py-20 bg-white relative">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 rounded-3xl bg-slate-50 hover:bg-cyan-50 transition-colors duration-300">
              <div className="w-14 h-14 bg-cyan-100 rounded-2xl flex items-center justify-center text-cyan-600 mb-6">
                <Zap size={28} />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{t.features.fastTitle}</h3>
              <p className="text-slate-600">{t.features.fastDesc}</p>
            </div>
            <div className="p-8 rounded-3xl bg-slate-50 hover:bg-orange-50 transition-colors duration-300">
              <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center text-orange-500 mb-6">
                <BarChart3 size={28} />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{t.features.statsTitle}</h3>
              <p className="text-slate-600">{t.features.statsDesc}</p>
            </div>
            <div className="p-8 rounded-3xl bg-slate-50 hover:bg-blue-50 transition-colors duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center text-blue-600 mb-6">
                <Shield size={28} />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{t.features.safeTitle}</h3>
              <p className="text-slate-600">{t.features.safeDesc}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50 border-t border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-8 flex items-center gap-3">
             <span className="w-2 h-8 bg-cyan-500 rounded-full"></span>
             {t.history.title}
          </h2>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
            {history.length > 0 ? (
              <div className="divide-y divide-slate-100">
                {history.map((item, index) => (
                  <div key={index} className="p-5 hover:bg-slate-50 transition-colors flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div className="flex-grow min-w-0">
                      <div className="flex items-center gap-3 mb-1">
                        <p className="text-lg font-bold text-cyan-600">{item.short}</p>
                        <span className="px-2 py-0.5 bg-slate-100 text-slate-500 text-xs rounded-md">{item.clicks} {t.history.clicks}</span>
                      </div>
                      <p className="text-sm text-slate-400 truncate">{item.original}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="text-xs text-slate-400 hidden sm:block">{item.date}</span>
                      <button onClick={() => copyToClipboard(item.short, index)} className="p-2 text-slate-400 hover:text-cyan-600 hover:bg-cyan-50 rounded-lg transition-all">
                        {copiedId === index ? <Check size={20} className="text-green-500"/> : <Copy size={20} />}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="p-10 text-center text-slate-400">{t.history.empty}</div>
            )}
          </div>
        </div>
      </section>
    </>
  );

  const FeaturesPage = () => (
    <div className="pt-16 pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 pt-10">
          <h2 className="text-base font-semibold text-cyan-600 tracking-wide uppercase">{t.pricing.headerTitle}</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            {t.pricing.headerMain}
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 mx-auto">
            {t.pricing.headerSub}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Guest Plan */}
          <div className="relative p-8 bg-white border border-slate-200 rounded-3xl shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col">
            <div className="mb-5">
              <h3 className="text-xl font-bold text-slate-900">{t.pricing.guest.title}</h3>
              <p className="text-slate-500 mt-2 text-sm">{t.pricing.guest.desc}</p>
            </div>
            <div className="mb-5">
              <span className="text-4xl font-extrabold text-slate-900">{t.pricing.guest.price}</span>
              <span className="text-slate-500"> {t.pricing.guest.period}</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start gap-3 text-slate-600 text-sm">
                <CheckCircle2 size={18} className="text-cyan-500 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.guest.f1}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-600 text-sm">
                <CheckCircle2 size={18} className="text-cyan-500 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.guest.f2}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-600 text-sm">
                <CheckCircle2 size={18} className="text-cyan-500 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.guest.f3}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <XCircle size={18} className="flex-shrink-0 mt-0.5" />
                <span>{t.pricing.guest.f4}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <XCircle size={18} className="flex-shrink-0 mt-0.5" />
                <span>{t.pricing.guest.f5}</span>
              </li>
            </ul>
            <button 
              onClick={() => setCurrentPage('home')}
              className="w-full py-3 px-6 border border-cyan-200 text-cyan-700 font-semibold rounded-xl hover:bg-cyan-50 transition-colors"
            >
              {t.pricing.guest.btn}
            </button>
          </div>

          {/* General Member Plan */}
          <div className="relative p-8 bg-slate-50 border border-cyan-200 rounded-3xl shadow-md hover:shadow-2xl transition-all duration-300 transform md:-translate-y-4 flex flex-col">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-1 rounded-full text-xs font-bold shadow-lg">
              {t.pricing.general.badge}
            </div>
            <div className="mb-5">
              <h3 className="text-xl font-bold text-slate-900 flex items-center gap-2">
                <User size={20} className="text-cyan-600"/> {t.pricing.general.title}
              </h3>
              <p className="text-slate-500 mt-2 text-sm">{t.pricing.general.desc}</p>
            </div>
            <div className="mb-5">
              <span className="text-4xl font-extrabold text-slate-900">{t.pricing.general.price}</span>
              <span className="text-slate-500"> {t.pricing.general.period}</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start gap-3 text-slate-700 text-sm">
                <CheckCircle2 size={18} className="text-cyan-500 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.general.f1}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-700 text-sm">
                <CheckCircle2 size={18} className="text-cyan-500 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.general.f2}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-700 text-sm">
                <CheckCircle2 size={18} className="text-cyan-500 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.general.f3}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-700 text-sm">
                <CheckCircle2 size={18} className="text-cyan-500 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.general.f4}</span>
              </li>
            </ul>
            <button className="w-full py-3 px-6 bg-cyan-900 text-white font-semibold rounded-xl hover:bg-slate-800 transition-colors shadow-lg shadow-slate-900/20">
              {t.pricing.general.btn}
            </button>
          </div>

          {/* Annual Member Plan */}
          <div className="relative p-8 bg-cyan-900 from-slate-900 to-slate-800 border border-slate-700 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 text-white flex flex-col">
             <div className="mb-5">
              <h3 className="text-xl font-bold text-white flex items-center gap-2">
                <Star size={20} className="text-yellow-400 fill-yellow-400"/> {t.pricing.annual.title}
              </h3>
              <p className="text-slate-400 mt-2 text-sm">{t.pricing.annual.desc}</p>
            </div>
            <div className="mb-5">
              <span className="text-4xl font-extrabold text-white">{t.pricing.annual.price}</span>
              <span className="text-slate-400"> {t.pricing.annual.period}</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <CheckCircle2 size={18} className="text-yellow-400 flex-shrink-0 mt-0.5" />
                <span className="text-white">{t.pricing.annual.f1}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <CheckCircle2 size={18} className="text-yellow-400 flex-shrink-0 mt-0.5" />
                <span className="text-white">{t.pricing.annual.f2}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <CheckCircle2 size={18} className="text-yellow-400 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.annual.f3}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <CheckCircle2 size={18} className="text-yellow-400 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.annual.f4}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <CheckCircle2 size={18} className="text-yellow-400 flex-shrink-0 mt-0.5" />
                <span>{t.pricing.annual.f5}</span>
              </li>
            </ul>
            <button className="w-full py-3 px-6 bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-bold rounded-xl hover:from-yellow-400 hover:to-orange-400 transition-colors shadow-lg shadow-orange-500/30">
              {t.pricing.annual.btn}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800 selection:bg-cyan-200 flex flex-col">
      
      {/* Navigation Bar */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div 
              className="flex items-center gap-2 cursor-pointer" 
              onClick={() => setCurrentPage('home')}
            >
              <div className="bg-gradient-to-tr from-cyan-400 to-blue-500 p-2 rounded-lg text-white shadow-lg shadow-cyan-500/30">
                <Scissors size={24} />
              </div>
              <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-600 to-blue-600">
                M108.COM
              </span>
            </div>
            <div className="flex space-x-8 text-sm font-medium text-slate-600">
              <button 
                onClick={() => setCurrentPage('features')}
                className={`transition-colors ${currentPage === 'features' ? 'text-cyan-600 font-bold' : 'hover:text-cyan-600'}`}
              >
                {t.nav.features}
              </button>
              <a href="#" className="hover:text-cyan-600 transition-colors">{t.nav.help}</a>
            </div>
            <div className="flex items-center gap-3">
              {/* Language Switcher */}
              <button 
                onClick={toggleLang}
                className=" p-2 text-slate-600 hover:text-cyan-600 hover:bg-cyan-50 rounded-full transition-all flex items-center gap-1 text-xs font-bold border border-slate-200"
              >
                <Globe size={16} />
                {lang === 'th' ? 'TH' : 'EN'}
              </button>

              <button className="hidden sm:block px-4 py-2 text-sm font-medium text-slate-600 hover:text-cyan-600 transition-colors">
                {t.nav.login}
              </button>
              <button className="hidden md:flex px-5 py-2.5 text-sm font-bold text-white bg-cyan-900 rounded-full hover:bg-slate-800 transition-all shadow-md hover:shadow-lg active:scale-95 bg-cyan-500">
                {t.nav.start}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content Switcher */}
      <div className="flex-grow">
        {currentPage === 'home' ? <HomePage /> : <FeaturesPage />}
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-slate-100 py-12 mt-auto">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="bg-cyan-900 p-1.5 rounded-md text-white">
              <Scissors size={16} />
            </div>
            <span className="text-lg font-bold text-slate-900">M108.COM</span>
            <span className="text-slate-400 text-sm ml-2">© 2023 {t.footer.rights}</span>
          </div>
          <div className="flex gap-6 text-slate-500">
            <a href="#" className="hover:text-cyan-600 transition-colors"><Github size={20} /></a>
            <a href="#" className="hover:text-cyan-600 transition-colors">{t.footer.privacy}</a>
            <a href="#" className="hover:text-cyan-600 transition-colors">{t.footer.terms}</a>
          </div>
        </div>
      </footer>
    </div>
  );
}